import styled from 'styled-components';
import { Typography } from '../../global/theme';
import { AlignCenter, FlexBetween } from '../../global/commonStyle';

interface IconHiddenProps {
  isDragging?: boolean;
}

const Title = styled.div`
  ${Typography.body_md_semibold}
  color: var(--text-primary);
`;
const LabelTitle = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;
const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--space-20);
  gap: var(--space-12);
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--shadow-card);
  border-radius: var(--border-radius-12);
`;
const Row = styled.div`
  ${FlexBetween}
  gap: var(--space-20);
  max-width: 463px;
  width: 100%;
`;
const LeftRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--space-0);
  gap: var(--space-4);
`;
const Subtitle = styled.div`
  ${Typography.body_sm}
  margin: var(--space-0);
  color: var(--text-secondary);
`;
const Autotext = styled.div`
  ${AlignCenter}
`;

const Tag = styled.div`
  cursor: pointer;
  color: var(--brand-primary);
  ${Typography.body_md_medium};
`;

const IconHidden = styled.div<IconHiddenProps>`
  position: absolute;
  left: -18px;
  top: 10px;
  width: 16px;
  height: 16px;
  cursor: ${({ isDragging }) => (isDragging ? 'grabbing' : 'pointer')};
  opacity: ${({ isDragging }) => (isDragging ? 0 : 1)};
  svg {
    opacity: 0;
  }
`;
export { Title, Box, Row, LeftRow, Subtitle, Autotext, Tag, LabelTitle, IconHidden };
